import ResourcePageHeader from "../../components/ResourcePage/ResourcePageHeader";
import ResourceTilesGrid from "../../components/ResourcePage/ResourceTileGrid";
import { useTaggedResourceTiles } from "../../components/ResourcePage/helpers/useTaggedResourceTiles";
import styles from "./GetResearchExperience.module.css";

const RESEARCH_TAG_FILTERS = ["Research Up Tiles", "Research Down Tiles"];

const SECTION_TITLES: Record<string, string> = {
  "Research Up Tiles":
    "Check out the research opportunities available in our Department, to get started:",
  "Research Down Tiles":
    "If you would like to find research opportunities elsewhere, here are some good ways to get started:",
};

const GetResearchExperience = () => {
  const taggedResourceTiles = useTaggedResourceTiles(RESEARCH_TAG_FILTERS);

  return (
    <>
      <ResourcePageHeader
        title="Looks like you want to get more research experience!"
        showTileCount={false}
        showSectionLinks={false}
        className={styles.getResearchExperienceHeader}
      />

      <div
        style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
        data-cy="get-research-experience-resources"
      >
        {taggedResourceTiles.map((section) => (
          <section key={section.tagFilter} className="resource-page-group">
            <p className={styles.getResearchExperienceSectionTitle}>
              {SECTION_TITLES[section.tagFilter]}
            </p>

            <ResourceTilesGrid
              resourceTiles={section.data}
              bookmarkSource="ResearchExperienceTile"
            />
          </section>
        ))}
      </div>
    </>
  );
};

export default GetResearchExperience;
